import type { SpecificationFigure } from '../types/specification-figures';

/**
 * 附图持久化服务接口。
 * 负责将说明书附图信息保存到本地或远端，并支持加载、清除等操作。
 * 可用于本地存储、IndexedDB、后端API等多种实现方式。
 */
export const FiguresPersistenceService = Symbol.for('FiguresPersistenceService');

/**
 * 附图持久化服务接口定义。
 */
export interface FiguresPersistenceService {
    /**
     * 保存附图信息。
     * @param figures 附图数组
     * @returns Promise<void>
     */
    saveFigures(figures: SpecificationFigure[]): Promise<void>;
    /**
     * 加载已持久化的附图信息。
     * @returns Promise<SpecificationFigure[]> 持久化的附图数组，若无则返回空数组
     */
    loadFigures(): Promise<SpecificationFigure[]>;
    /**
     * 清除已持久化的附图信息。
     * @returns Promise<void>
     */
    clearFigures(): Promise<void>;
}
